type RowObj = {
  name: string;
  formation: string;
  date: string;
  testPassed: string;
};

const tableDataComplex: RowObj[] = [
  {
    name: "Esmail Khorchani",
    formation: "Nextjs",
    testPassed: "Passé",
    date: "06 Juin 2023",
  },
  {
    name: "Ala mhadhbi",
    formation: "Reactjs",
    testPassed: "Non passé",
    date: "04 Juin 2023",
  },
  {
    name: "Karim Mejri",
    formation: "Spring boot",
    testPassed: "Faillure",
    date: "01 Juin 2023",
  },
];
export default tableDataComplex;
